export const useIsAnimationsOff = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
